import React from 'react';
import { Route } from 'react-router-dom';
import Layout from '../../../Layout/index';
import Commerce from './Commerce';
import Crypto from './Crypto';
import Documentation from './Documentation';
import DefaultPages from './DefaultPages';
import Account from './Account';
import ECommerce from './ECommerce';
import Maps from './Maps';
import Charts from './Charts';
import Tables from './Tables';
import Forms from './Forms';
import UI from './UI';

import Chat from '../../../Chat/index';
import Todo from '../../../Todo/index';

import FitnessDashboard from '../../../Dashboards/Fitness/index';
import DefaultDashboard from '../../../Dashboards/Default/index';
import MobileAppDashboard from '../../../Dashboards/MobileApp/index';
import BookingDashboard from '../../../Dashboards/Booking/index';

import Mail from '../../../Mail/index';
import Target from './Target';
import Customers from './Customers';
import Blasts from './Blasts';
import BlackList from './BlackList';
import Bets from './Bets';
import Reports from './Reports';
import Finance from './Finance';
import users from './users';
import { FAQs } from '../../../FAQs/faq';
import { CustomersWithdrwals } from '../../../Finance/customerwithdraws';
import { Transaction } from '../../../Finance/transaction';
import { DepositRequests } from '../../../Finance/depositrequests';
import { QueeMessages } from '../../../Blasts/bulksms';
import { UserSearchLuckyNumber } from '../../../users/usersearchluckynumber';
import { UserDetailsLuckNumber } from '../../../users/userdetailsluckynumber';
import { BoundDepositMessages } from '../../../users/depositlucky';
import { BoundWithdrawalMessages } from '../../../users/withdrawallucky';
import { Players, PlayersDS } from '../../../users/Players';
import { CustomersHr } from '../../../users/Customers';
import { BoundLucyMessages } from '../../../users/uckybounds';
import UsersStaffs from '../../../users/UsersStaffs';
import { CustomerHour } from '../../../users/CustomersPerHour';
import { PlayersHour } from '../../../users/PlayersP';
import { UserSearchDetails } from '../../../users/usersearchlgetcollectdetail';
import { UserDetailsLudoExpress } from '../../../users/userdetailsludoepxress';
import { UserSearchLudoExpress } from '../../../users/usersearchludoexpress';
import { BoundWithdrawalMessagesLudo } from '../../../users/withdrawalludo';
import { BoundDepositMessagesLudo } from '../../../users/depositludo';
import { BoundLudoMessages } from '../../../users/ludobounds';
import { PlayersLudo } from '../../../users/PlayersLudo';
import { PlayersJackPoot } from '../../../users/PlayersJackPot';
import { PlayersJackKitty } from '../../../users/PlayersJackKiity';

export default () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route path="/dashboard_default" component={DefaultDashboard} />
      <Route path="/dashboard_e_commerce" component={Commerce} />
      <Route path="/dashboard_fitness" component={FitnessDashboard} />
      <Route path="/dashboard_crypto" component={Crypto} />
      <Route exact path="/dashboard_mobile_app" component={MobileAppDashboard} />
      <Route path="/dashboard_booking" component={BookingDashboard} />
      <Route path="/ui" component={UI} />
      <Route path="/target" component={Target} />
      <Route path="/termscon" component={FAQs} />
      <Route path="/mail" component={Mail} />
      <Route path="/chat" component={Chat} />
      <Route path="/todo" component={Todo} />
      <Route path="/forms" component={Forms} />
      <Route path="/tables" component={Tables} />
      <Route path="/charts" component={Charts} />
      <Route path="/maps" component={Maps} />
      <Route path="/account" component={Account} />
      <Route path="/customers" component={Customers} />
      <Route path="/customers-withdrawals" component={CustomersWithdrwals} />
      <Route path="/transaction" component={Transaction} />
      <Route path="/DepositRequests" component={DepositRequests} />
      <Route path="/users" component={UsersStaffs} />


      <Route path="/stats" component={CustomerHour} />
      <Route path="/player_hours" component={PlayersHour} />

      <Route path="/blasts" component={Blasts} />
      <Route path="/scheduled_message" component={QueeMessages} />

      <Route path="/user_search" component={UserSearchLuckyNumber} />
      <Route path="/user_search_ludo" component={UserSearchLudoExpress} />

      <Route path="/all_message_all" component={BoundLucyMessages} />

      <Route path="/all_message_all_ludo" component={BoundLudoMessages} />

      <Route path="/jackpot_winners_kit" component={PlayersJackPoot} />

      <Route path="/jackpot_kitty" component={PlayersJackKitty} />
      <Route path="/players" component={PlayersDS} />

      <Route path="/players_ludo" component={PlayersLudo} />

      <Route path="/user_details_ludo" component={UserDetailsLudoExpress} />

      <Route path="/user_details_lucky" component={UserDetailsLuckNumber} />
      <Route path="/perhour" component={CustomersHr} />



      <Route path="/user_details_lucky_withdrawal" component={BoundWithdrawalMessages} />
      <Route path="/user_details_lucky_deposit" component={BoundDepositMessages} />

      <Route path="/user_details_ludo_deposit" component={BoundDepositMessagesLudo} />

      <Route path="/user_details_ludo_withdrawal" component={BoundWithdrawalMessagesLudo} />


      <Route path="/" component={BlackList} />
      <Route path="/" component={Bets} />
      <Route path="/" component={Reports} />
      <Route path="/" component={Finance} />
      <Route path="/" component={users} />
      <Route path="/e-commerce" component={ECommerce} />
      <Route path="/default_pages" component={DefaultPages} />
      <Route path="/documentation" component={Documentation} />
    </div>
  </div>
);
